import { render, staticRenderFns } from "./MultipleRadioButton.vue?vue&type=template&id=49c0b670&scoped=true"
import script from "./MultipleRadioButton.vue?vue&type=script&lang=js"
export * from "./MultipleRadioButton.vue?vue&type=script&lang=js"
import style0 from "./MultipleRadioButton.vue?vue&type=style&index=0&id=49c0b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0b670",
  null
  
)

export default component.exports